export const WHATSAPP_NUMBER = "5511984077080";
export const WHATSAPP_DISPLAY = "(11) 98407-7080";
export const EMAIL = "biags@yahoo.com.br";

const baseMsg =
    "Olá! Visitei o site da CAJUSP e gostaria de conversar sobre arbitragem e mediação empresarial.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(baseMsg)}`;
export const EMAIL_URL = `mailto:${EMAIL}?subject=${encodeURIComponent("Contato — CAJUSP")}`;

export const NAV_LINKS = [
    { id: "instituicao", href: "#instituicao", label: "A Instituição" },
    { id: "arbitragem", href: "#arbitragem", label: "Arbitragem" },
    { id: "segmentos", href: "#segmentos", label: "Segmentos" },
    { id: "diferencial", href: "#diferencial", label: "Diferencial" },
    { id: "calculadora", href: "#calculadora", label: "Calculadora" },
    { id: "clausula", href: "#clausula", label: "Cláusula Modelo" },
    { id: "faq", href: "#faq", label: "FAQ" },
    { id: "contato", href: "#contato", label: "Contato" },
];

export const MARQUEE_ITEMS = [
    "Segurança Jurídica",
    "Confidencialidade",
    "Especialização",
    "Autonomia das Partes",
    "Previsibilidade",
];

export const FAQS = [
    {
        q: "O que é uma câmara arbitral?",
        a: "Uma câmara arbitral é uma instituição privada especializada em administrar procedimentos de arbitragem e mediação. A CAJUSP — Câmara de Juízo Arbitral e Mediação Empresarial de São Paulo oferece estrutura, regras e secretaria para que conflitos empresariais, contratuais e patrimoniais sejam resolvidos fora do Poder Judiciário, com independência e imparcialidade.",
    },
    {
        q: "Como resolver conflitos empresariais sem recorrer ao Judiciário?",
        a: "Por meio da arbitragem ou da mediação. Na arbitragem, as partes submetem a controvérsia a árbitros especializados, e a sentença arbitral tem os mesmos efeitos da sentença judicial. Na mediação, um terceiro neutro facilita o diálogo para a construção conjunta de uma solução, preservando a relação comercial.",
    },
    {
        q: "Como resolver conflitos entre sócios por arbitragem?",
        a: "Se o contrato social ou o acordo de sócios prevê cláusula compromissória, as disputas societárias — como dissolução, apuração de haveres ou divergências de gestão — são submetidas à arbitragem. O procedimento permite julgadores com conhecimento em direito societário e, conforme a convenção das partes e o regulamento, pode preservar a confidencialidade das informações do negócio.",
    },
    {
        q: "A arbitragem é sigilosa?",
        a: "A arbitragem não é automaticamente sigilosa em todas as situações. A confidencialidade deve ser estabelecida e observada conforme a legislação aplicável, os regulamentos institucionais e os compromissos assumidos pelas partes. Quando prevista, protege informações estratégicas, contratos e dados financeiros envolvidos no conflito.",
    },
    {
        q: "A sentença arbitral tem a mesma força de uma decisão judicial?",
        a: "Sim. Conforme o artigo 31 da Lei nº 9.307/1996, a sentença arbitral produz, entre as partes e seus sucessores, os mesmos efeitos da sentença proferida pelos órgãos do Poder Judiciário e, quando condenatória, constitui título executivo.",
    },
    {
        q: "Qual a diferença entre arbitragem e mediação de conflitos empresariais?",
        a: "Na arbitragem, o tribunal arbitral decide a controvérsia de forma definitiva e obrigatória. Na mediação, o mediador não decide: ele conduz a negociação para que as próprias partes construam o acordo. A mediação costuma ser indicada quando a preservação da relação comercial, societária ou contratual é prioridade.",
    },
];

export const PILLARS = [
    {
        roman: "I",
        title: "Segurança Jurídica",
        text: "A arbitragem é reconhecida e regulamentada pela legislação brasileira. A Lei nº 9.307/1996 estabelece os fundamentos do procedimento arbitral, e a força da sentença arbitral — reconhecida pela própria lei — oferece às partes segurança quanto aos efeitos jurídicos da decisão.",
    },
    {
        roman: "II",
        title: "Confidencialidade",
        text: "Relações empresariais envolvem informações estratégicas, contratos, patrimônio, operações comerciais e dados financeiros. A arbitragem possibilita que as partes estabeleçam regras de confidencialidade para o procedimento, respeitadas as disposições legais e regulamentares aplicáveis.",
    },
    {
        roman: "III",
        title: "Especialização",
        text: "Conflitos complexos exigem conhecimento específico sobre o objeto da controvérsia. Na arbitragem, as partes participam da definição do mecanismo de escolha dos árbitros, permitindo contar com profissionais compatíveis com a natureza do conflito.",
    },
    {
        roman: "IV",
        title: "Autonomia das Partes",
        text: "As partes podem convencionar previamente que determinadas controvérsias serão submetidas à arbitragem, definindo, dentro dos limites legais, aspectos relevantes do procedimento. A convenção arbitral deixa de ser apenas uma cláusula e passa a ser um instrumento de planejamento jurídico.",
    },
    {
        roman: "V",
        title: "Previsibilidade",
        text: "Conhecer previamente o mecanismo de solução de disputas — regras procedimentais, constituição do tribunal arbitral e parâmetros da convenção e do regulamento — organiza as relações contratuais e representa importante medida de gestão de riscos.",
    },
];

export const COMPARISON = [
    {
        aspect: "Julgador",
        court: "Magistrado de carreira, sem especialização específica garantida",
        arb: "Árbitros com conhecimento compatível com a natureza da controvérsia",
    },
    {
        aspect: "Prazo",
        court: "Processos que podem se estender por anos, com múltiplos recursos",
        arb: "Procedimento concentrado, com etapas e prazos definidos em regulamento",
    },
    {
        aspect: "Publicidade",
        court: "Processos, em regra, públicos",
        arb: "Confidencialidade possível, conforme a lei, o regulamento e a convenção das partes",
    },
    {
        aspect: "Instâncias",
        court: "Duas ou mais instâncias recursais",
        arb: "Sentença arbitral definitiva, com força de título executivo",
    },
    {
        aspect: "Previsibilidade",
        court: "Ritos padronizados, sem adaptação ao caso concreto",
        arb: "Regras e procedimento conhecidos previamente pelas partes",
    },
];

export const CLAUSE_TEXT =
    "Todas as controvérsias decorrentes ou relacionadas ao presente contrato, incluindo as relativas à sua existência, validade, eficácia, interpretação, execução, violação ou rescisão, serão definitivamente solucionadas por arbitragem, administrada pela CAJUSP — Câmara de Juízo Arbitral e Mediação Empresarial de São Paulo, de acordo com o seu Regulamento de Arbitragem. O Tribunal Arbitral será composto por [um árbitro / três árbitros], nomeados conforme o referido Regulamento. A sede da arbitragem será a cidade de São Paulo, Estado de São Paulo; o idioma será o português; e a lei aplicável ao mérito será a legislação brasileira. A sentença arbitral será definitiva e obrigatória para as partes e seus sucessores, nos termos da Lei nº 9.307/1996.";

// Tabela de referência PROVISÓRIA para a calculadora (faixas marginais regressivas)
export const ADMIN_BRACKETS = [
    { upTo: 100000, rate: 0.04 },
    { upTo: 500000, rate: 0.025 },
    { upTo: 1000000, rate: 0.015 },
    { upTo: 5000000, rate: 0.009 },
    { upTo: 20000000, rate: 0.005 },
    { upTo: Infinity, rate: 0.0025 },
];
export const ADMIN_MIN = 4000;

export const FEE_BRACKETS = [
    { upTo: 100000, rate: 0.1 },
    { upTo: 500000, rate: 0.06 },
    { upTo: 1000000, rate: 0.04 },
    { upTo: 5000000, rate: 0.025 },
    { upTo: 20000000, rate: 0.012 },
    { upTo: Infinity, rate: 0.006 },
];
export const FEE_MIN = 12000;

export const estimateByBrackets = (value, brackets, min) => {
    let total = 0;
    let prev = 0;
    for (const b of brackets) {
        const amount = Math.min(value, b.upTo) - prev;
        if (amount > 0) total += amount * b.rate;
        prev = b.upTo;
        if (value <= b.upTo) break;
    }
    return Math.max(total, min);
};

export const HERO_IMAGE = {
    url: "/hero-cajusp.jpg",
    alt: "Sala de sessões da CAJUSP — mesa de mármore e logotipo da instituição na parede",
};

export const BUILDING_IMAGE = {
    url: "https://images.unsplash.com/photo-1523477593243-78bbf626fd3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NjV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBnbGFzcyUyMGNvcnBvcmF0ZSUyMGJ1aWxkaW5nJTIwZmFjYWRlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4OTMzMjY5MHww&ixlib=rb-4.1.0&q=85",
    alt: "Fachada geométrica de vidro e aço de centro financeiro",
};

export const HANDSHAKE_IMAGE = {
    url: "https://images.unsplash.com/photo-1681505531034-8d67054e07f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBidXNpbmVzcyUyMGFncmVlbWVudCUyMGhhbmRzaGFrZSUyMGZvdW50YWluJTIwcGVuJTIwZG9jdW1lbnR8ZW58MHx8fHwxNzkxNzQ0OTA5fDA&ixlib=rb-4.1.0&q=85",
    alt: "Acordo empresarial e assinatura de contrato com caneta-tinteiro",
};
